import { useMemo, useState } from "react";
import Side from "../Partials/Side";
import { ToastContainer, toast } from "react-toastify";
import { Bars } from "react-loader-spinner";
import "react-toastify/dist/ReactToastify.css";
import { goods, service, spaces } from "../../data";
//import { countries } from 'countries-list';
import Select from "react-select";
import countryList from "react-select-country-list";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
function Notification() {
  //const countryCodes = Object.keys(countries);
  const options = useMemo(() => countryList().getData(), []);

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const token = localStorage.getItem("token");
  const [loaded, setLoaded] = useState(true);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [subCategories, setsubCategories] = useState([]);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [actionId, setActionId] = useState("");
  const [imageUrl, setImageUrl] = useState("");

  function handleImageUpload(e) {
    const formData = new FormData();
    formData.append('newImage', e.target.files[0]);
    
    fetch(`http://24.199.104.72/api/upload-single-image`, {
      method: "POST",
      body: formData
    })
      .then((res) => res.json())
      .then((response) => {
        setImageUrl(response.imageUrl);
        toast.success("Image uploaded successfully");
      })
      .catch((error) => {
        toast.error("Failed to upload image");
      });
  }

  function handleRemoveImage() {
    setImageUrl("");
  }

  function clearAllStates() {
    setTitle("");
    setMessage("");
    setType("");
    setActionId("");
    setImageUrl("");
    setPhone("");
    setsubCategories([]);
    setSubCategoryData([]);
    
    // Reset file inputs
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach(input => {
      input.value = '';
    });
  }

  function handleSubmit(e) {
    let title1 = document.getElementById("title1").value;
    let msg1 = document.getElementById("msg1").value;
    e.preventDefault();

    if (title1 == "") {
      toast.error("please enter Title");
    }
    if (title1.trim() == "") {
      toast.error("please enter valid Title");
    }
    if (msg1 == "") {
      toast.error("please enter message");
    }
    if (msg1.trim() == "") {
      toast.error("please enter valid message");
    } else {
      setLoaded(false);
      let formData = { title, message, type, actionId, imageUrl };
      console.log(title, message, type, actionId, imageUrl);
      fetch(`http://24.199.104.72/api/notifications/users`, {
        method: "POST",
        headers: {
          Authorization: `bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((res) => {
          return res.json();
        })
        .then((response) => {
          if (response.status === true) {
            toast.success(response.message);
            clearAllStates();
            setLoaded(true);
          } else {
            toast.error("notification couldn't send");
            setLoaded(true);
          }
        })
        .catch((error) => {
          toast.error("Failed to send notification");
          setLoaded(true);
        });
    }
  }

  function handleCheckBox(e) {
    const { value, checked } = e.target;
    if (checked) {
      setsubCategories((prevCheckedItems) => [...prevCheckedItems, value]);
    } else {
      setsubCategories((prevCheckedItems) =>
        prevCheckedItems.filter((item) => item !== value)
      );
    }
  }
  function handleSubmitByCategory(e) {
    let title3 = document.getElementById("title3").value;
    let msg3 = document.getElementById("msg3").value;
    e.preventDefault();

    if (title3 == "") {
      toast.error("please enter Title");
    }
    if (title3.trim() == "") {
      toast.error("please enter valid Title");
    }
    if (msg3 == "") {
      toast.error("please enter message");
    }
    if (msg3.trim() == "") {
      toast.error("please enter valid message");
    } else {
      setLoaded(false);

      let formData = { title, message, subCategories, type, actionId, imageUrl };
      console.log(title, message, subCategories, type, actionId, imageUrl);
      fetch(`http://24.199.104.72/api/notifications/sub-categories`, {
        method: "POST",
        headers: {
          Authorization: `bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((res) => {
          return res.json();
        })
        .then((response) => {
          if (response.status === true) {
            toast.success(response.message);
            clearAllStates();
            setLoaded(true);
          }
          if (response.status === false) {
            toast.error("notification couldn't send");
            setLoaded(true);
          }
        })
        .catch((error) => {
          toast.error("Failed to send notification");
          setLoaded(true);
        });
    }
  }
  function handleSubmitPaticular(e) {
    let title2 = document.getElementById("title2").value;
    let msg2 = document.getElementById("msg2").value;
    e.preventDefault();

    if (title2 === "") {
      toast.error("please enter Title");
    }
    if (title2.trim() === "") {
      toast.error("please enter valid Title");
    }
    if (msg2 === "") {
      toast.error("please enter message");
    }
    if (msg2.trim() === "") {
      toast.error("please enter valid message");
    } else {
      setLoaded(false);

      let formData = { title, message, phone, type, actionId, imageUrl };
      console.log(formData);
      fetch(`http://24.199.104.72/api/notifications/users/phone`, {
        method: "POST",
        headers: {
          Authorization: `bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((res) => {
          return res.json();
        })
        .then((response) => {
          if (response.status == true) {
            toast.success(response.message);
            clearAllStates();
            setLoaded(true);
          }
          if (response.status == false) {
            toast.error(response.message);
            setLoaded(true);
          }
        })
        .catch((error) => {
          toast.error("Failed to send notification");
          setLoaded(true);
        });
    }
  }
  function handleCategory(e) {
    if (e.target.value == "0") {
      setSubCategoryData(goods);
    }
    if (e.target.value == "1") {
      setSubCategoryData(service);
    }
    if (e.target.value == "2") {
      setSubCategoryData(spaces);
      // console.log(categorydata.goods)
    }
  }

  console.log(code);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Side />
          <div className="col-md-2"></div>

          <div className="col-md-10">
            {loaded == false ? (
              <div
                className="loader"
                style={{ 
                  display: "flex", 
                  justifyContent: "center", 
                  alignItems: "center",
                  height: "80vh" 
                }}
              >
                <Bars
                  height="60"
                  width="60"
                  color="#179778"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              </div>
            ) : (
              <>
                <ToastContainer position="top-right" autoClose={3000} />
                <div className="mt-4 mb-5">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="fw-bold" style={{ color: "#179778" }}>
                      📢 Send Notifications
                    </h2>
                  </div>
                  <p className="text-muted mb-4">
                    Send notifications to all users, specific users by phone, or users in specific categories
                  </p>
                </div>
                <div
                  className="accordion shadow-sm"
                  id="accordionExample"
                  style={{ display: "block", borderRadius: "10px" }}
                >
                  <div className="accordion-item border-0 mb-3" style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button fw-semibold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        style={{ backgroundColor: "#f8f9fa", color: "#179778" }}
                      >
                        🌐 Send Notification To All Users
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body" style={{ backgroundColor: "#fafafa" }}>
                        <div className="send-noti-div-p">
                          <div className="send-noti-div p-4" style={{ backgroundColor: "white", borderRadius: "10px" }}>
                            <form
                              method="post"
                              onSubmit={(e) => {
                                handleSubmit(e);
                              }}
                            >
                              <div className="mb-3">
                                <label className="form-label fw-semibold">📝 Title</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={title}
                                  onChange={(e) => {
                                    setTitle(e.target.value);
                                  }}
                                  id="title1"
                                  placeholder="Enter notification title"
                                  style={{ padding: "10px" }}
                                />
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">💬 Message</label>
                                <textarea
                                  className="form-control"
                                  value={message}
                                  onChange={(e) => {
                                    setMessage(e.target.value);
                                  }}
                                  id="msg1"
                                  rows="4"
                                  placeholder="Enter notification message"
                                  style={{ padding: "10px" }}
                                ></textarea>
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🔖 Type</label>
                                <select
                                  className="form-select"
                                  value={type}
                                  onChange={(e) => {
                                    setType(e.target.value);
                                  }}
                                  style={{ padding: "10px" }}
                                >
                                  <option value="">Select Type</option>
                                  <option value="profile">Profile</option>
                                  <option value="listing">Listing</option>
                                  <option value="request">Request</option>
                                </select>
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🔗 Action ID</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={actionId}
                                  onChange={(e) => {
                                    setActionId(e.target.value);
                                  }}
                                  placeholder="Enter action ID"
                                  style={{ padding: "10px" }}
                                />
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🖼️ Upload Image</label>
                                <input
                                  type="file"
                                  className="form-control"
                                  accept="image/*"
                                  onChange={handleImageUpload}
                                  style={{ padding: "10px" }}
                                />
                                {imageUrl && (
                                  <div className="mt-3 text-center p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                                    <img
                                      src={imageUrl}
                                      alt="Notification"
                                      style={{ 
                                        width: "150px", 
                                        height: "150px", 
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: "2px solid #179778"
                                      }}
                                    />
                                    <br />
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm mt-3"
                                      onClick={handleRemoveImage}
                                    >
                                      🗑️ Remove Image
                                    </button>
                                  </div>
                                )}
                              </div>

                              <button
                                type="submit"
                                className="btn send-btn w-100 mt-4"
                                style={{ 
                                  backgroundColor: "#179778", 
                                  color: "white",
                                  padding: "12px",
                                  fontWeight: "600",
                                  border: "none"
                                }}
                              >
                                🚀 Send Notification
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item border-0 mb-3" style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed fw-semibold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                        style={{ backgroundColor: "#f8f9fa", color: "#179778" }}
                      >
                        📱 Send Notification To Particular User
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body" style={{ backgroundColor: "#fafafa" }}>
                        <div className="send-noti-div-p">
                          <div className="send-noti-div p-4" style={{ backgroundColor: "white", borderRadius: "10px" }}>
                            <form
                              method="post"
                              onSubmit={(e) => {
                                handleSubmitPaticular(e);
                              }}
                            >
                              <div className="mb-3">
                                <label className="form-label fw-semibold">📝 Title</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={title}
                                  onChange={(e) => {
                                    setTitle(e.target.value);
                                  }}
                                  id="title2"
                                  placeholder="Enter notification title"
                                  style={{ padding: "10px" }}
                                />
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">💬 Message</label>
                                <textarea
                                  className="form-control"
                                  value={message}
                                  onChange={(e) => {
                                    setMessage(e.target.value);
                                  }}
                                  id="msg2"
                                  rows="4"
                                  placeholder="Enter notification message"
                                  style={{ padding: "10px" }}
                                ></textarea>
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">📞 Phone Number</label>
                                <PhoneInput
                                  placeholder="Enter phone number"
                                  value={phone}
                                  onChange={setPhone}
                                  className="form-control"
                                  style={{ padding: "10px" }}
                                />
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🔖 Type</label>
                                <select
                                  className="form-select"
                                  value={type}
                                  onChange={(e) => {
                                    setType(e.target.value);
                                  }}
                                  style={{ padding: "10px" }}
                                >
                                  <option value="">Select Type</option>
                                  <option value="profile">Profile</option>
                                  <option value="listing">Listing</option>
                                  <option value="request">Request</option>
                                </select>
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🔗 Action ID</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={actionId}
                                  onChange={(e) => {
                                    setActionId(e.target.value);
                                  }}
                                  placeholder="Enter action ID"
                                  style={{ padding: "10px" }}
                                />
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🖼️ Upload Image</label>
                                <input
                                  type="file"
                                  className="form-control"
                                  accept="image/*"
                                  onChange={handleImageUpload}
                                  style={{ padding: "10px" }}
                                />
                                {imageUrl && (
                                  <div className="mt-3 text-center p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                                    <img
                                      src={imageUrl}
                                      alt="Notification"
                                      style={{ 
                                        width: "150px", 
                                        height: "150px", 
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: "2px solid #179778"
                                      }}
                                    />
                                    <br />
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm mt-3"
                                      onClick={handleRemoveImage}
                                    >
                                      🗑️ Remove Image
                                    </button>
                                  </div>
                                )}
                              </div>

                              <button
                                type="submit"
                                className="btn send-btn w-100 mt-4"
                                style={{ 
                                  backgroundColor: "#179778", 
                                  color: "white",
                                  padding: "12px",
                                  fontWeight: "600",
                                  border: "none"
                                }}
                              >
                                🚀 Send Notification
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item border-0 mb-3" style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed fw-semibold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                        style={{ backgroundColor: "#f8f9fa", color: "#179778" }}
                      >
                        📂 Send Notification By Sub-Categories
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body" style={{ backgroundColor: "#fafafa" }}>
                        <div className="send-noti-div-p">
                          <div className="send-noti-div p-4" style={{ backgroundColor: "white", borderRadius: "10px" }}>
                            <form
                              method="post"
                              onSubmit={(e) => {
                                handleSubmitByCategory(e);
                              }}
                            >
                              <div className="mb-3">
                                <label className="form-label fw-semibold">📝 Title</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={title}
                                  onChange={(e) => {
                                    setTitle(e.target.value);
                                  }}
                                  id="title3"
                                  placeholder="Enter notification title"
                                  style={{ padding: "10px" }}
                                />
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">💬 Message</label>
                                <textarea
                                  className="form-control"
                                  value={message}
                                  onChange={(e) => {
                                    setMessage(e.target.value);
                                  }}
                                  id="msg3"
                                  rows="4"
                                  placeholder="Enter notification message"
                                  style={{ padding: "10px" }}
                                ></textarea>
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">📦 Category</label>
                                <select
                                  className="form-select"
                                  onChange={(e) => {
                                    handleCategory(e);
                                  }}
                                  id="cate"
                                  style={{ padding: "10px" }}
                                >
                                  <option selected>Select Category</option>
                                  <option value="0">Goods</option>
                                  <option value="1">Services</option>
                                  <option value="2">Spaces</option>
                                </select>
                              </div>

                              {subCategoryData?.length > 0 && (
                                <div className="mb-3">
                                  <label className="form-label fw-semibold">✅ Select Sub-Categories</label>
                                  <div className="p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                                    {subCategoryData?.map((i, index) => (
                                      <div className="form-check mb-2" key={index}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`subcategory-${index}`}
                                          checked={subCategories.includes(i)}
                                          value={i}
                                          onChange={handleCheckBox}
                                          style={{ cursor: "pointer" }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`subcategory-${index}`}
                                          style={{ cursor: "pointer" }}
                                        >
                                          {i}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🔖 Type</label>
                                <select
                                  className="form-select"
                                  value={type}
                                  onChange={(e) => {
                                    setType(e.target.value);
                                  }}
                                  style={{ padding: "10px" }}
                                >
                                  <option value="">Select Type</option>
                                  <option value="profile">Profile</option>
                                  <option value="listing">Listing</option>
                                  <option value="request">Request</option>
                                </select>
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🔗 Action ID</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={actionId}
                                  onChange={(e) => {
                                    setActionId(e.target.value);
                                  }}
                                  placeholder="Enter action ID"
                                  style={{ padding: "10px" }}
                                />
                              </div>

                              <div className="mb-3">
                                <label className="form-label fw-semibold">🖼️ Upload Image</label>
                                <input
                                  type="file"
                                  className="form-control"
                                  accept="image/*"
                                  onChange={handleImageUpload}
                                  style={{ padding: "10px" }}
                                />
                                {imageUrl && (
                                  <div className="mt-3 text-center p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                                    <img
                                      src={imageUrl}
                                      alt="Notification"
                                      style={{ 
                                        width: "150px", 
                                        height: "150px", 
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: "2px solid #179778"
                                      }}
                                    />
                                    <br />
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm mt-3"
                                      onClick={handleRemoveImage}
                                    >
                                      🗑️ Remove Image
                                    </button>
                                  </div>
                                )}
                              </div>

                              <button
                                type="submit"
                                className="btn send-btn w-100 mt-4"
                                style={{ 
                                  backgroundColor: "#179778", 
                                  color: "white",
                                  padding: "12px",
                                  fontWeight: "600",
                                  border: "none"
                                }}
                              >
                                🚀 Send Notification
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Notification;
